import States from './states'
import StatesQuery, { LIST_STATES_QUERY } from './states.query'

export { StatesQuery, LIST_STATES_QUERY }

export default States
